<template>
  <v-app-bar id="app-bar" app fixed height="75" elevate-on-scroll style="-webkit-app-region: drag">
    <v-btn class="mr-3" elevation="1" fab small style="-webkit-app-region: no-drag" @click="setDrawer(!drawer)">
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>
    <v-menu v-if="loggedIn" offset-y style="-webkit-app-region: no-drag">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-3" elevation="1" fab small v-bind="attrs" style="-webkit-app-region: no-drag" v-on="on">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item style="-webkit-app-region: no-drag">
          <logout-modal @ok="okLogout" />
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    /> -->

    <v-spacer />

    <!-- <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      style="max-width: 165px;"
    >
      <template
        v-if="$vuetify.breakpoint.mdAndUp"
        v-slot:append-outer
      >
        <v-btn
          class="mt-n2"
          elevation="1"
          fab
          small
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field> -->

    <div class="mx-3" />
    <patch-notes style="-webkit-app-region: no-drag" />
    <div v-if="isElectron" class="d-flex">
      <v-btn class="ml-2" min-width="0" text style="-webkit-app-region: no-drag" @click="minimizeWindow">
        <v-icon>mdi-window-minimize</v-icon>
      </v-btn>
      <v-btn class="ml-2" min-width="0" text style="-webkit-app-region: no-drag"
             @click="fullscreenWindow(isFullscreen)">
        <v-icon>{{ isFullscreen ? 'mdi-dock-window' : 'mdi-window-maximize' }}</v-icon>
      </v-btn>
      <div style="-webkit-app-region: no-drag">
        <close-dialogue @close-window="closeWindow" />
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import CloseDialogue from '@/views/dashboard/component/CloseDialogue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { closeApp, isMaximized, maximizeWindow, minimizeWindow } from '../../../../lib/electron-utils'

export default {
  name: 'DashboardCoreAppBar',

  components: {
    LogoutModal: () => import('@/modals/LogoutModal'),
    CloseDialogue,
    PatchNotes: () => import('./PatchNotes.vue'),
    // AppBarItem: {
    //   render (h) {
    //     return h(VHover, {
    //       scopedSlots: {
    //         default: ({ hover }) => {
    //           return h(VListItem, {
    //             attrs: this.$attrs,
    //             class: {
    //               'black--text': !hover,
    //               'white--text secondary elevation-12': hover,
    //             },
    //             props: {
    //               activeClass: '',
    //               dark: hover,
    //               link: true,
    //               ...this.$attrs,
    //             },
    //           }, this.$slots.default)
    //         },
    //       },
    //     })
    //   },
    // },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isFullscreen: isMaximized(),
    resetCoolDown: false,
  }),
  created() {
  },
  computed: {
    ...mapState({
      drawer: state => state.drawer,
      loggedIn: state => state.auth.loggedIn,
    }),
    isElectron() {
      return process && process.versions && process.versions.electron
    },
  },

  watch: {
    loggedIn(val) {
      if (!val) {
        this.$router.push({ name: 'Login' })
      }
    },
  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
    }),
    ...mapActions({
      logout: 'auth/logout',
    }),
    fullscreenWindow() {
      this.isFullscreen = maximizeWindow()
    },
    minimizeWindow: () => {
      minimizeWindow()
    },
    closeWindow: close => {
      closeApp()
    },
    okLogout() {
      this.logout()
    },
  },
}
</script>
